export default "__VITE_ASSET__bsHcSYaV__"